import { BaseIcon } from '../BaseIcon';
import type { BaseIconProps } from '../BaseIcon';

type ColumnsIconProps = Omit<BaseIconProps, 'children'>;

export const ColumnsIcon = ({ ...props }: ColumnsIconProps) => (
  <BaseIcon width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <rect x="5" y="5" width="4" height="14" stroke="#141B4D" strokeWidth="2" fill="none" />
    <rect x="13.5" y="5" width="4" height="14" stroke="#141B4D" strokeWidth="2" fill="none" />
    <path d="M12 15.5L19 8.5" stroke="#141B4D" strokeWidth="2" strokeLinecap="round" />
  </BaseIcon>
);

ColumnsIcon.displayName = 'ColumnsIcon';
